export default __webpack_public_path__ + "static/media/thumbnail.41c1611e.png";